export const period = [
  { value: 0, label: "All time" },
  { value: 1, label: "Day" },
  { value: 2, label: "Week" },
  { value: 3, label: "Month" },
  { value: 4, label: "Custom" },
];

export const paymentOptions = [
  { value: 1, label: "Online" },
  { value: 2, label: "Cash" },
  { value: 3, label: "Pin" },
  { value: 4, label: "Generated" },
  { value: 7, label: "Uploaded" },
  { value: 5, label: "Guest" },
  { value: 8, label: "Seasonal" },
  { value: 9, label: "Invoice" },
];
